<template>
    <PageSidebar>
        <template #sidebarTitle>
            <span>{{ $t("ticker.menu.events") }} </span>
        </template>
        <template #sidebarMain>
            <div class="p-6 space-y-3">
                <EventCard
                    v-for="event in eventTypes"
                    :key="event.code"
                    :item="event"
                    @click="$emit('edit', event)"
                    @edit="$emit('edit', event)"
                />
            </div>
        </template>
        <template #sidebarFooter>
            <cSaveButton @save="saveSnapshot" :disabled="!hasChanges" />
        </template>
    </PageSidebar>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { PageSidebar } from "@easy/ui/page-components";
import EventCard from "./EventCard.vue";
import cSaveButton from "@/shared/components/cSaveButton.vue";
import { tickersService } from "@/apps/ticker/services/tickers.service";

export default {
    components: {
        PageSidebar,
        EventCard,
        cSaveButton,
    },
    emits: ["add", "edit"],
    data() {
        return {
            eventTypes: tickersService.getEventTypes(),
        };
    },
    computed: {
        ...mapState("ticker", ["hasChanges"]),
    },
    methods: {
        ...mapActions("ticker", ["saveSnapshot"]),
    },
};
</script>
